import { hasOwnProperty } from "@next-core/utils/general";
import { isEvaluable } from "@next-core/cook";
import { setupTemplateExternalBricksWithForEach } from "./setupTemplateProxy.js";
import { childrenToSlots } from "../Renderer.js";
export function replaceSlotWithSlottedBricks(brickConf, hostContext, expand) {
  var _brickConf$properties, _brickConf$properties2, _defaultSlots$$bricks, _defaultSlots$;
  // Currently, no support for `if` in a slot.
  if (brickConf.if != null && !brickConf.if || typeof brickConf.if === "string") {
    throw new Error(`Can not use "if" in a slot currently, check your template "${hostContext.hostBrick.type}"`);
  }
  const slot = String((_brickConf$properties = (_brickConf$properties2 = brickConf.properties) === null || _brickConf$properties2 === void 0 ? void 0 : _brickConf$properties2.name) !== null && _brickConf$properties !== void 0 ? _brickConf$properties : "");

  // Currently, no support for expression as slot name.
  if (isEvaluable(slot)) {
    throw new Error(`Can not use an expression as slot name "${slot}" currently, check your template "${hostContext.hostBrick.type}"`);
  }

  // Do not repeat the same slot name in a template.
  if (hostContext.usedSlots.has(slot)) {
    throw new Error(`Can not have multiple slots with the same name "${slot}", check your template "${hostContext.hostBrick.type}"`);
  }
  hostContext.usedSlots.add(slot);
  if (hostContext.externalSlots && hasOwnProperty(hostContext.externalSlots, slot)) {
    var _hostContext$external;
    const insertBricks = (_hostContext$external = hostContext.externalSlots[slot].bricks) !== null && _hostContext$external !== void 0 ? _hostContext$external : [];
    if (insertBricks.length > 0) {
      const hostCtx = hostContext.hostBrick.runtimeContext;
      // External bricks of a template, should not access the template internal forEach `ITEM`.
      // For some existing templates who is *USING* this bug, we keep the old behavior.
      const hostHasForEach = hasOwnProperty(hostCtx, "forEachItem");
      return hostHasForEach ? setupTemplateExternalBricksWithForEach(insertBricks, hostCtx.forEachItem, hostCtx.forEachIndex, hostCtx.forEachSize) : insertBricks;
    }
  }
  const defaultSlots = childrenToSlots(brickConf.children, brickConf.slots);
  return ((_defaultSlots$$bricks = defaultSlots === null || defaultSlots === void 0 || (_defaultSlots$ = defaultSlots[""]) === null || _defaultSlots$ === void 0 ? void 0 : _defaultSlots$.bricks) !== null && _defaultSlots$$bricks !== void 0 ? _defaultSlots$$bricks : []).flatMap(item => expand(item, hostContext));
}
//# sourceMappingURL=replaceSlotWithSlottedBricks.js.map